import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../../components/datagrid/GridToolBar';
import { useSelector, useDispatch } from 'react-redux';
import { getReportingHeadSkillWillKra } from '../../../redux/features/appraisalSlice';

const TeamSkillWillKra = ({ type, user }) => {
  const [gridSize, setGridSize] = useState(10);
  const dispatch = useDispatch();

  const { reportingHeadSkillWillKra, loading } = useSelector((state) => state.appraisal);

  const columns = [
    {
      field: 'sl_no',
      headerName: 'SL No',
      width: 100,
    },
    {
      field: 'userName',
      headerName: 'User Name',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'libraryName',
      headerName: type,
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'libraryDescription',
      headerName: 'Description',
      flex: 1,
      minWidth: 250,
    },
    {
      field: 'appraisal_weightage',
      headerName: 'Appraisal Weightage (%)',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'created_on',
      headerName: 'Created On',
      width: 200,
      renderCell: (params) => {
        // Format date to readable form (optional)
        const date = new Date(params.value);
        return date.toLocaleString('en-IN', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
  ];

  useEffect(() => {
    const data = {
      page: 1,
      limit: 'no',
      type: type,
    };
    dispatch(getReportingHeadSkillWillKra(data));
  }, [type]);
  return (
    <GlobalWrapper>
      <Box>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={reportingHeadSkillWillKra}
          columns={columns}
          loading={loading}
          getRowId={(row) => row.sl_no}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TeamSkillWillKra;
